import Vue from 'vue'
import VueRouter from 'vue-router'
import MemoriesWall from '../views/MemoriesWall.vue'
import MyMemories from '../views/MyMemories.vue'
import PendingRequests from '../views/PendingRequests.vue'
import FamilyTree from '../views/FamilyTree.vue'
import AddMemories from '../views/AddMemories.vue'
import Settings from '../views/Settings.vue'
import AccountActivation from '../views/AccountActivation.vue'
import Profile from '../views/Profile.vue'
import Login from '../views/Login.vue'
import Landing from '../views/Landing.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import Bookmarks from '../views/Bookmarks.vue'
import TermsAndConditions from '../views/TermsAndConditions.vue'
import FAQ from '../views/FAQ.vue'
import Reports from '../views/Reports.vue'
// todo uncomment this line to enable statistics
// import Statistics from '../views/Statistics.vue'
import store from '../store'

import demoProfile from '../views/demo/Profile.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Landing',
    component: Landing
  },
  {
    path: '/ForgotPassword/:guid?',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
    path: '/TermsAndConditions/',
    name: 'TermsAndConditions',
    component: TermsAndConditions,
  },
  {
    path: '/FAQ/',
    name: 'FAQ',
    component: FAQ,
  },
  {
    path: '/Reports/',
    name: 'Reports',
    component: Reports,
    meta: { requiresAuth: true }
  },
  {
    path: '/Bookmarks/',
    name: 'Bookmarks',
    component: Bookmarks,
    meta: { requiresAuth: true }
  },
  // {
  //   path: '/Statistics/',
  //   name: 'Statistics',
  //   component: Statistics,
  //   meta: { requiresAuth: true }
  // },
  {
    path: '/AccountActivation/:guid?/',
    name: 'AccountActivation',
    component: AccountActivation
  },
  {
    path: '/Login',
    name: 'Login',
    component: Login
  },
  {
    path: '/MemoriesWall',
    name: 'MemoriesWall',
    component: MemoriesWall,
    meta: { requiresAuth: true }
  },
  {
    path: '/MyMemories',
    name: 'MyMemories',
    component: MyMemories,
    meta: { requiresAuth: true }
  },
  {
    path: '/AddMemories',
    name: 'AddMemories',
    component: AddMemories,
    meta: { requiresAuth: true }
  },
  {
    path: '/PendingRequests',
    name: 'PendingRequests',
    component: PendingRequests,
    meta: { requiresAuth: true }
  },
  {
    path: '/FamilyTree',
    name: 'FamilyTree',
    component: FamilyTree,
    meta: { requiresAuth: true }
  },
  {
    path: '/Profile/:id/',
    name: 'Profile',
    component: Profile,
    meta: { requiresAuth: true }
  },
  {
    path: '/Settings',
    name: 'Settings',
    component: Settings,
    meta: { requiresAuth: true }
  },

  // DEMO
  {
    path: '/demo/Profile',
    name: 'DemoProfile',
    component: demoProfile
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // if (window.localStorage.getItem('token')) {
    //   next()
    // } else {
    store.dispatch('user/getUserProfile').then(() => {
      const currentUser = store.state.user.currentUser;
      var color = "#3093a5";
      switch (currentUser?.theme) {
        case "no-theme":
        case "theme-default":
          color = "#3093a5";
          break;
        case "theme-black":
          color = "#000000";
          break;
        case "theme-blue-gray":
          color = "#607D8B";
          break;
        case "theme-blue":
          color = "#1E88E5";
          break;
        case "theme-cyan":
          color = "#00B8D4";
          break;
        case "theme-dark-red":
          color = "#D50000";
          break;
        case "theme-green":
          color = "#64DD17";
          break;
        case "theme-light-green":
          color = "#00C853";
          break;
        case "theme-light-brown":
          color = "#8D6E63";
          break;
        case "theme-lime-dark":
          color = "#9E9D24";
          break;
        case "theme-orange":
          color = "#F57C00";
          break;
        case "theme-pink":
          color = "#FF4081";
          break;
        case "theme-light-purple":
          color = "#E040FB";
          break;
        case "theme-purple":
          color = "#800080";
          break;
      }

      document
        .querySelector('meta[name="theme-color"]')
        ?.setAttribute("content", color);

      if (window.localStorage.getItem('token')) {
        store.commit('setToken', window.localStorage.getItem('token'), { root: true })
        next()
      }
      else {
        var lang = window.localStorage.getItem("lang")
        localStorage.clear()
        window.localStorage.setItem("lang", lang)
        next({
          path: '/'
        })
      }
    })

    //}
  } else {
    if (to.name !== 'Landing') {
      const currentTheme = localStorage.getItem("theme") || "no-theme";
      var color = "#3093a5";
      switch (currentTheme) {
        case "no-theme":
        case "theme-default":
          color = "#3093a5";
          break;
        case "theme-black":
          color = "#000000";
          break;
        case "theme-blue-gray":
          color = "#607D8B";
          break;
        case "theme-blue":
          color = "#1E88E5";
          break;
        case "theme-cyan":
          color = "#00B8D4";
          break;
        case "theme-dark-red":
          color = "#D50000";
          break;
        case "theme-green":
          color = "#64DD17";
          break;
        case "theme-light-green":
          color = "#00C853";
          break;
        case "theme-light-brown":
          color = "#8D6E63";
          break;
        case "theme-lime-dark":
          color = "#9E9D24";
          break;
        case "theme-orange":
          color = "#F57C00";
          break;
        case "theme-pink":
          color = "#FF4081";
          break;
        case "theme-light-purple":
          color = "#E040FB";
          break;
        case "theme-purple":
          color = "#800080";
          break;
      }

      document
        .querySelector('meta[name="theme-color"]')
        ?.setAttribute("content", color);
    }
    next()
  }
})

export default router
